module.exports = __webpack_public_path__ + "img/protest-invest.42146c39.svg";